import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog'
import { Component, Inject } from '@angular/core';

export class ConfirmDialogModel {

  constructor(public title: string, public message: string, public type: string, public logout: boolean) {
  }
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirmdialog.component.html'
})
export class ConfirmdialogComponent {
  title: string;
  message: string;
  type: string;
  logout: boolean;

  constructor(public dialogRef: MatDialogRef<ConfirmdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    this.title = data.title;
    this.message = data.message;
    this.type = data.type;
    this.logout = data.logout;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

  onOk(): void {
    this.dialogRef.close(true);
  }
}


